export function updateMessageAtIndex(messages, messageIndex, updateMessage) {
  const message = messages[messageIndex];
  if (!message) return messages;

  const updatedMessage = updateMessage(message);
  if (updatedMessage === message) return messages;

  const nextMessages = [...messages];
  nextMessages[messageIndex] = updatedMessage;
  return nextMessages;
}

// Updates are addressed by id, not index: a callback from a stream that has been
// aborted or superseded finds no matching message in the newly selected chat and
// leaves that chat untouched.
export function updateMessageById(messages, messageId, updateMessage) {
  const messageIndex = messages.findIndex(message => message.id === messageId);
  if (messageIndex === -1) return messages;
  return updateMessageAtIndex(messages, messageIndex, updateMessage);
}

export function appendMessageChunk(messages, messageId, content) {
  return updateMessageById(messages, messageId, (message) => ({
    ...message,
    text: message.text + content,
    isThinking: false,
  }));
}
